import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_calendar';
export const route = 'modify_calendar/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_calendar" */
/* webpackPrefetch: true */
'../components/CalendarPage')));